import script from "./portal-dynamic-addon.vue?vue&type=script&setup=true&lang=ts"
export * from "./portal-dynamic-addon.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__